import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/msc/msc.jpg'


const _withScopeId = n => (_pushScopeId("data-v-4c2d9f5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark sticky-top bg-lav" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, "Ms Clean", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_6 = { class: "navbar-nav ms-auto" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "#"
  }, "Inicio")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  href: "#servi"
}, "Servicios", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "#about"
  }, "Sobre Nosotros")
], -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"hero\" data-v-4c2d9f5e></div><div class=\"container my-5\" id=\"about\" data-v-4c2d9f5e><div class=\"row\" data-v-4c2d9f5e><div class=\"col-md-6\" data-v-4c2d9f5e><img src=\"" + _imports_0 + "\" alt=\"Calidad Premium\" class=\"img-fluid\" data-v-4c2d9f5e></div><div class=\"col-md-6 d-flex flex-column justify-content-center\" data-v-4c2d9f5e><h2 data-v-4c2d9f5e> Misión Y Visión</h2><span data-v-4c2d9f5e> La misión de Miss Clean es brindar a sus clientes una solución de limpieza y desinfección integral, rápida y efectiva, con el objetivo de mejorar la calidad de vida de las personas y garantizar la salud y seguridad de los ambientes en los que se desenvuelven. La empresa se enfoca en brindar un servicio personalizado y de calidad, con una atención al cliente excepcional y un enfoque en la satisfacción del cliente. </span><br data-v-4c2d9f5e><span data-v-4c2d9f5e> La visión de Miss Clean es convertirse en la empresa líder en limpieza y desinfección de hogares y negocios en la ciudad de Chetumal, ofreciendo servicios innovadores y eficientes que mejoren la calidad de vida de las personas y contribuyan a un entorno más saludable. La empresa busca expandirse a nuevas ciudades y regiones, con la misión de ayudar a más personas a mantener sus hogares y negocios limpios y saludables </span></div></div></div>", 2)
const _hoisted_14 = {
  key: 0,
  class: "testimonials text-center"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-4c2d9f5e><div class=\"row\" data-v-4c2d9f5e><div class=\"col-md-4\" data-v-4c2d9f5e><blockquote class=\"blockquote\" data-v-4c2d9f5e><p data-v-4c2d9f5e>&quot;Best laundry service in Chetumal! La mejor lavandería de Chetumal!&quot;</p><footer class=\"blockquote-footer\" data-v-4c2d9f5e>Alejandro P.</footer></blockquote></div><div class=\"col-md-4\" data-v-4c2d9f5e><blockquote class=\"blockquote\" data-v-4c2d9f5e><p data-v-4c2d9f5e>&quot;Hasta ahorita es la mejor lavandería que he encontrado en Chetumal y el plus es que aceptan tarjetas!&quot;</p><footer class=\"blockquote-footer\" data-v-4c2d9f5e>Victor D.</footer></blockquote></div><div class=\"col-md-4\" data-v-4c2d9f5e><blockquote class=\"blockquote\" data-v-4c2d9f5e><p data-v-4c2d9f5e>&quot;Súper rápido en 1 día todo estaba limpio y personal muy agradable!&quot;</p><footer class=\"blockquote-footer\" data-v-4c2d9f5e>Javier V.</footer></blockquote></div></div></div>", 1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "container my-5",
  id: "servi"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Nuestros Servicios", -1))
const _hoisted_19 = { class: "row text-center services div-con-scroll" }
const _hoisted_20 = {
  class: "card shadow-lg",
  style: {"width":"22rem"}
}
const _hoisted_21 = { class: "div-img-top" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://api.whatsapp.com/send?phone=5219831392289&text=Buen%20d%C3%ADa%2C%20me%20interesa%20el%20servicio%20de%20recolecci%C3%B3n%20y%20lavado%20para%20negocio.",
      target: "_blank",
      class: "btn"
    }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "btn btn-primary btn-lg",
        style: {"background":"linear-gradient(90deg, #20c997, #0d6efd)","border":"none"}
      }, " Solicitar el Servicio ")
    ])
  ])
], -1))
const _hoisted_24 = {
  key: 2,
  class: "container my-5"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Sucursales", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Suc. Erick Paolo"),
    /*#__PURE__*/_createElementVNode("p", null, "Av. Erick Paolo entre Av. Magisterio y Miguel Alemán"),
    /*#__PURE__*/_createElementVNode("p", null, "Tel: 983 133 81 11"),
    /*#__PURE__*/_createElementVNode("iframe", {
      src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.0870457985434!2d-88.31167992420299!3d18.524968169038765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5ba4a363940a1b%3A0xf33826ef64921713!2sLavanderia%20Premium!5e0!3m2!1ses-419!2smx!4v1720576627889!5m2!1ses-419!2smx",
      width: "600",
      height: "450",
      style: {"border":"0"},
      allowfullscreen: "false",
      loading: "lazy",
      class: "branch-map",
      referrerpolicy: "no-referrer-when-downgrade"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Suc. Américas I"),
    /*#__PURE__*/_createElementVNode("p", null, "Av. Luis Manuel Sevilla entre Guyana y Paraguay"),
    /*#__PURE__*/_createElementVNode("p", null, "Tel: 983 139 22 89"),
    /*#__PURE__*/_createElementVNode("iframe", {
      src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30260.753199012815!2d-88.30733235303559!3d18.547233611297514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5ba5e7b8a4f265%3A0xa537cc7a01434944!2sLavanderia%20Premium%20Sucursal!5e0!3m2!1ses-419!2smx!4v1726331091787!5m2!1ses-419!2smx",
      width: "600",
      height: "450",
      style: {"border":"0"},
      allowfullscreen: "false",
      loading: "lazy",
      class: "branch-map",
      referrerpolicy: "no-referrer-when-downgrade"
    })
  ])
], -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 3,
  class: "container my-5 text-center"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Algunos de nuestros Clientes", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://api.whatsapp.com/send?phone=5219831392289&text=Buen%20d%C3%ADa%2C%20me%20interesa%20el%20servicio%20de%20recolecci%C3%B3n%20y%20lavado%20para%20negocio.",
    target: "_blank",
    class: "btn btn-primary"
  }, "Solicita una Cotización")
], -1))

import { Iservicios } from '@/app/model/servicios';
import { ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'mscleeanview',
  setup(__props) {

const services: Ref<Iservicios[]> = ref([
    {
        img: require('@/assets/img/lp/servicios/servicio (1).png'),
        alt: 'servicio1'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (2).png'),
        alt: 'servicio2'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (3).png'),
        alt: 'servicio3'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (4).png'),
        alt: 'servicio4'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (5).png'),
        alt: 'servicio5'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (6).png'),
        alt: 'servicio6'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (10).png'),
        alt: 'servicio10'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (11).png'),
        alt: 'servicio11'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (12).png'),
        alt: 'servicio12'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (13).png'),
        alt: 'servicio13'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (14).png'),
        alt: 'servicio14'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (15).png'),
        alt: 'servicio15'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (16).png'),
        alt: 'servicio16'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (17).png'),
        alt: 'servicio17'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (18).png'),
        alt: 'servicio18'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (19).png'),
        alt: 'servicio19'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (20).png'),
        alt: 'servicio20'
    }
]);

const clients: Ref<Iservicios[]> = ref([
    {
        img: require('../assets/img/lp/clientes/clientes (1).png'),
        alt: 'cliente 1'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (2).png'),
        alt: 'cliente 2'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (3).png'),
        alt: 'cliente 3'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (4).png'),
        alt: 'cliente 4'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (5).png'),
        alt: 'cliente 5'
    },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _hoisted_7,
            false
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, _hoisted_10))
              : _createCommentVNode("", true),
            _hoisted_11
          ])
        ])
      ])
    ]),
    _hoisted_12,
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex justify-content-center align-items-center mt-3 col-md-3",
                key: service.alt
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("img", {
                      src: service.img,
                      class: "img-fluid",
                      alt: service.alt
                    }, null, 8, _hoisted_22)
                  ]),
                  _hoisted_23
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value, (client) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-md-2",
                key: client.alt
              }, [
                _createElementVNode("img", {
                  src: client.img,
                  alt: client.alt
                }, null, 8, _hoisted_31)
              ]))
            }), 128))
          ]),
          _hoisted_32
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})